export const FACILITY_NO_AVAILABLE_SLOTS_ERROR_CODES: string[] = [
  "APPOINTMENT_FACILITY_UNAVAILABLE",
  "EVENT_OCCURRENCE_FACILITY_UNAVAILABLE",
];

export const STAFF_NO_AVAILABLE_SLOTS_ERROR_CODES: string[] = [
  "APPOINTMENT_STAFF_UNAVAILABLE",
  "EVENT_OCCURRENCE_STAFF_UNAVAILABLE",
];

export const STAFF_AND_FACILITY_NO_AVAILABLE_SLOTS_ERROR_CODES: string[] = [
  "EVENT_OCCURRENCE_STAFF_AND_FACILITY_UNAVAILABLE",
  "APPOINTMENT_STAFF_AND_FACILITY_UNAVAILABLE",
];

/*** @deprecated - In the future we should not use the error paths to handle expected application behavior */
export const NO_AVAILABLE_SLOTS_ERROR_CODES: string[] = [
  ...FACILITY_NO_AVAILABLE_SLOTS_ERROR_CODES,
  ...STAFF_NO_AVAILABLE_SLOTS_ERROR_CODES,
  ...STAFF_AND_FACILITY_NO_AVAILABLE_SLOTS_ERROR_CODES,
];

/*** @deprecated - In the future we should not use the error paths to handle expected application behavior */
export const MANUALLY_HANDLED_ERROR_CODES: string[] = [
  ...NO_AVAILABLE_SLOTS_ERROR_CODES,
  "EVENT_OCCURRENCE_HAS_FULL_BOOKING_CAPACITY",
];
